import { navLinks, profile } from '../../data/site';

function scrollToId(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/*--------------------
* Footer Section
----------------------*/
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-tint/[.07] bg-panel/60 py-12">
      <div className="container">
        <div className="grid gap-9 lg:grid-cols-12">
          <div className="reveal lg:col-span-5">
            <button
              onClick={() => scrollToId('home')}
              className="font-display text-[18px] font-[600] tracking-[-.02em] text-chalk transition-opacity duration-200 hover:opacity-70"
              aria-label="Back to top"
            >
              Dikshit Patoliya
            </button>

            <p className="mt-4 max-w-[42ch] text-[14px] leading-[1.65] text-muted">
              React Native engineer building AI-native mobile products for teams in the US,
              Canada and Europe. Based in {profile.location}.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <a className="chip" href={profile.linkedin} target="_blank" rel="noreferrer">
                LinkedIn <span aria-hidden="true">&#8599;</span>
              </a>
              <a className="chip" href={`mailto:${profile.email}`}>
                Email <span aria-hidden="true">&#8599;</span>
              </a>
            </div>
          </div>

          <div className="reveal lg:col-span-3" style={{ transitionDelay: '.08s' }}>
            <h3 className="font-mono text-[11px] uppercase tracking-[.2em] text-muted">Explore</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToId(link.id)}
                    className="text-[14px] text-muted transition-colors hover:text-chalk"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal lg:col-span-4" style={{ transitionDelay: '.16s' }}>
            <h3 className="font-mono text-[11px] uppercase tracking-[.2em] text-muted">
              Start a project
            </h3>
            <p className="mt-4 text-[14px] leading-[1.65] text-muted">
              Currently taking on new work. Reply within one working day.
            </p>
            <button className="btn btn-primary btn-sm mt-4" onClick={() => scrollToId('contact')}>
              Get in touch <span aria-hidden="true">&rarr;</span>
            </button>
          </div>
        </div>

        <div className="hairline my-9" />

        <p className="text-center font-mono text-[12px] tracking-[.04em] text-tint/50 sm:text-left">
          © {year} {profile.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
